module.exports = __webpack_public_path__ + "static/media/icon-home.264130ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/icon-home.svg
// module id = 126
// module chunks = 0